export const PAGE_WIDTH = "750px";
export const JOIN_US_MSG =
  "Thanks for connecting with us. We have received many inquiries from various organizations to address our food distribution needs. We shall re-open this page as soon as there is an additional need.";
